module.exports = __webpack_public_path__ + "img/live-white.d093463.gif";